import { useEffect, useState } from "react";
import {
  useGetAccountDetailsQuery,
  useGetDashboardGoogleAnalyticsQuery,
  useGetDashboardTotalCountQuery,
  useGetLinkClickDataQuery,
  useGetPageClickDataQuery,
  useGetSocialAgeDataQuery,
  useGetSocialEngagementDataQuery,
  useGetSocialReachDataQuery,
} from "../../../../Service/dashboard";
import SocialMediaCount from "../socialmedia-analytics/SocialMediaCount";
import { Col, Row } from "react-bootstrap";
//import ChartBox from "../component/ChartBox";
import Chart from "../component/Chart";
import ChartMin from "../component/ChartMin";
import { AgeCompareChart } from "../component/AgeCompareChart";
import LineChart from "../component/LineChart";
import Progressbar from "../component/Progressbar";
import Feedback from "./Feedback";
//import CitiesSpotlight from "./CitiesSpotlight";
import CountUp from "react-countup";
import up from "../../../../assets/DigitalMarketing/image/dashboard/arrow_up.svg";
import down from "../../../../assets/DigitalMarketing/image/dashboard/arrow down.svg";
import { BsThreeDots } from "react-icons/bs";
import circle from "../../../../assets/DigitalMarketing/image/dashboard/circle_down.svg";
import ChartBoxSmall from "../component/ChartBoxSmall";
import CompareChartSmall from "../component/CompareChartSmall";
import ChartBoxMin from "../component/ChartBoxMin";
import FacebookChart from "../component/FacebookChart";
import InstagramChart from "../component/InstagramChart";
import PerformChart from "../component/PerformChart";
import {
  AudienceLikes,
  Clicks,
  FacebookAge,
  FacebookClicks,
  FacebookTab,
  GoogleAge,
  Impressions,
  InstagramTab,
  PerformaceTab,
  PostAndEngagement,
  ReachAndImpressionTab,
  ReachDummy,
} from "./utils/data";
import { useDispatch } from "react-redux";
import { Reset } from "../../../../store/async-actions/digitalmarketing/header";
import { convertAdIds, convertLinkClicks, convertPageClicks, transformAgeData, transformImpressionData, transformReachData } from "./utils";
import Dropdown from "../../../../Component/DigitalMarketing/Forms/Dropdown";
import { useGetFacebooksettingQuery } from "../../../../Service/Integration";
import { BarChart } from "@mui/x-charts";
//import { BiLineChart } from "react-icons/bi";

function SocialMediaAnalytics() {
  const demodata = [
    {
      "account_id": "790217869575410",
      "campaign_id": "120208128620260769",
      "adset_id": "120208128620370769",
      "date_start": "2024-02-21",
      "date_stop": "2024-05-20",
      "impressions": "10241",
      "spend": "100",
      "adsName": {
          "name": "Post: \"“Turning your tech troubles into triumphs”\"",
          "id": "120208128620370769"
      }
  },
  {
      "account_id": "790217869575410",
      "campaign_id": "120208128697220769",
      "adset_id": "120208128697320769",
      "date_start": "2024-02-21",
      "date_stop": "2024-05-20",
      "impressions": "7955",
      "spend": "99.96",
      "adsName": {
          "name": "Instagram Post",
          "id": "120208128697320769"
      }
  }
];
const { data: facebookSetting } = useGetFacebooksettingQuery("1", {
  refetchOnMountOrArgChange: true,
});
// console.log(facebookSetting);
const { data: AccountDetail } = useGetAccountDetailsQuery(null, {
  refetchOnMountOrArgChange: true,
});

// console.log(AccountDetail);
 const Accontd = convertAdIds(AccountDetail?.data);
// console.log(Accontd);
// console.log(Accontd.length);

const [source, setSource] = useState(Accontd[0]?.id);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Reset());
  }, []);
  const { data } = useGetDashboardTotalCountQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const { data: GoogleAnalytics } = useGetDashboardGoogleAnalyticsQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const { data: SocialAge } = useGetSocialAgeDataQuery(source||null, {
    refetchOnMountOrArgChange: true,
  });
  const { data: SocialReach } = useGetSocialReachDataQuery(source||null, {
    refetchOnMountOrArgChange: true,
  });
  // console.log(SocialReach?.data_impression);
  // console.log(SocialReach?.data_reach);


  const { data: PageClick } = useGetPageClickDataQuery(source||null, {
    refetchOnMountOrArgChange: true,
  });  
  const { data: links } = useGetLinkClickDataQuery(source||null, {
    refetchOnMountOrArgChange: true,
  });
  const { data: SocialEngagements } = useGetSocialEngagementDataQuery(source||null, {
    refetchOnMountOrArgChange: true,
  });
  // console.log(SocialEngagements);



 

  // console.log(GoogleAnalytics);
  // console.log(SocialAge?.data);
  // console.log(links?.data);
  // console.log(PageClick?.data);

 

  let dashboardCountList = [];
  let AudienceCount = [
    {
      id: 1,
      title: "Post engagement",
      list: parseInt(SocialEngagements?.data[0]?.actions[1]?.value||0),
    },
    {
      id: 2,
      title: "Total campaign",
      list: Accontd.length||0,
    },
    {
      id: 3,
      title: "Reach",
      list: parseInt(SocialReach?.data_reach[0]?.reach||0),
    },
    {
      id: 4,
      title: "Impressions",
      list: parseInt(SocialReach?.data_impression[0]?.impressions||0,
  )  }
  ];
  const CountList = AudienceCount;

  const Source = [
    { id: "whatsapp", name: "Whatsapp" },
  
    { id: "facebook", name: "Facebook" },
    { id: "instagram", name: "Instagram" },
    { id: "google", name: "Google" },
    { id: "twitter", name: "Twitter" },
    { id: "linkedin", name: "Linkedin" },
    { id: "youtube", name: "Youtube" },
  ];
  if (GoogleAnalytics) {
    const totalCountValue = Object.values(GoogleAnalytics);
    dashboardCountList = AudienceCount.map((item, index) => {
      item.list = totalCountValue[index];
      return item;
    });
  }
  // console.log(dashboardCountList);

  const reachdata = [
    {
        "reach": "9735",
        "date_start": "2024-02-16",
        "date_stop": "2024-05-15"
    }
];
const LinkClicks =  [
  [
      {
          "inline_link_clicks": "85",
          "date_start": "2024-04-01",
          "date_stop": "2024-04-30"
      }
  ],
  [
      {
          "inline_link_clicks": "0",
          "date_start": "2024-03-01",
          "date_stop": "2024-03-31"
      }
  ],
  [
      {
          "inline_link_clicks": "0",
          "date_start": "2024-02-01",
          "date_stop": "2024-02-29"
      }
  ],
  [
      {
          "inline_link_clicks": "0",
          "date_start": "2024-01-01",
          "date_stop": "2024-01-31"
      }
  ],
  [
      {
          "inline_link_clicks": "0",
          "date_start": "2023-12-01",
          "date_stop": "2023-12-31"
      }
  ],
  [
      {
          "inline_link_clicks": "0",
          "date_start": "2023-11-01",
          "date_stop": "2023-11-30"
      }
  ]
]
const PageClicks =[
      [
          {
              "clicks": "107",
              "date_start": "2024-04-01",
              "date_stop": "2024-04-30"
          }
      ],
      [
          {
              "clicks": "0",
              "date_start": "2024-03-01",
              "date_stop": "2024-03-31"
          }
      ],
      [
          {
              "clicks": "0",
              "date_start": "2024-02-01",
              "date_stop": "2024-02-29"
          }
      ],
      [
          {
              "clicks": "0",
              "date_start": "2024-01-01",
              "date_stop": "2024-01-31"
          }
      ],
      [
          {
              "clicks": "0",
              "date_start": "2023-12-01",
              "date_stop": "2023-12-31"
          }
      ],
      [
          {
              "clicks": "0",
              "date_start": "2023-11-01",
              "date_stop": "2023-11-30"
          }
      ]
  ]

const Agedata =  [
  {
      "impressions": "580",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "25-34",
      "gender": "female"
  },
  {
      "impressions": "2076",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "25-34",
      "gender": "male"
  },
  {
      "impressions": "2",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "25-34",
      "gender": "unknown"
  },
  {
      "impressions": "750",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "35-44",
      "gender": "female"
  },
  {
      "impressions": "2811",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "35-44",
      "gender": "male"
  },
  {
      "impressions": "4",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "35-44",
      "gender": "unknown"
  },
  {
      "impressions": "465",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "45-54",
      "gender": "female"
  },
  {
      "impressions": "1574",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "45-54",
      "gender": "male"
  },
  {
      "impressions": "1",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "45-54",
      "gender": "unknown"
  },
  {
      "impressions": "333",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "55-64",
      "gender": "female"
  },
  {
      "impressions": "850",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "55-64",
      "gender": "male"
  },
  {
      "impressions": "2",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "55-64",
      "gender": "unknown"
  },
  {
      "impressions": "278",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "65+",
      "gender": "female"
  },
  {
      "impressions": "514",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "65+",
      "gender": "male"
  },
  {
      "impressions": "1",
      "date_start": "2024-02-16",
      "date_stop": "2024-05-15",
      "age": "65+",
      "gender": "unknown"
  }
];
const ImpressionData = [
{
  "impressions": "10241",
  "date_start": "2024-02-16",
  "date_stop": "2024-05-15"
}];
const onHandleChange = (event) => {
  const { name, value } = event.target;

    setSource(value);
  
};

const Reach = transformReachData(SocialReach?.data_reach);
// console.log(Reach);
const Impression = transformImpressionData(SocialReach?.data_impression);
// console.log(Impression);
const agedata = transformAgeData(SocialAge?.data);
  // console.log(agedata);
  
  // const pageclicks = convertPageClicks(PageClicks);
  // console.log(pageclicks);
  const pageclick = convertPageClicks(PageClick?.data);
  // console.log(pageclick);
  const linkclicks = convertLinkClicks(links?.data);
  // console.log(linkclicks);
  // const linkclicks = convertLinkClicks(LinkClicks);
  // console.log(linkclicks);
  // setSource(Accontd[0]?.name);
  const colorsbar: string[] = ['#6842D9', '#EEEEEE'];

  useEffect(() => {
   
  }, [source])
  useEffect(() => {
    setSource(Accontd[0]?.id);
  }, [AccountDetail])

  return (
    <>
      <h3 className="f-20 fw-600">Audience </h3>
      <Row>
      <Col className="mb-3" md={12} lg={6}>
</Col>
<Col className="mb-3" md={12} lg={6}>
<Dropdown
              option={Accontd}
              ids="id"
              source={source}
              defaults="Your ad campaign"
              list_name="name"
              key_name="source"
              handleChange={onHandleChange}
            />
</Col>
      </Row>
      <Row className="mt-3 mb-3">
        <Col className="mb-3" md={12} lg={6}>
          <SocialMediaCount CountList={CountList} />
        </Col>
        {/* <Col className="mb-3" sm={12} md={6} lg={6}>
          <CompareChartSmall
            element={<AgeCompareChart data={!facebookSetting?.userAccountId?FacebookAge:agedata} />}
            title="Age group"
          />
        </Col> */}

        {/* <Col className="mb-3" sm={12} md={6} lg={4}>
          <ChartBoxSmall
            element={<Progressbar />}
            title="Audience Likes"
            tablist={AudienceLikes}
          />
        </Col> */}
      {/* </Row>
      <Row> */}
      <Col className="mb-3" sm={12} md={6} lg={6}>
          <CompareChartSmall
            element={<BarChart
              xAxis={[{ scaleType: 'band', data: ["18-24", "25-34", "35-44", "45-54", "55-64", "65+"]}]}
              series={!facebookSetting?.userAccountId?FacebookAge:agedata}
              colors={colorsbar}
              width={500}
              height={300}
            />}
            title="Age group"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col className="mb-3" sm={12} md={6} lg={6}>
          <PerformChart
            element={<LineChart data={!facebookSetting?.userAccountId?Clicks:pageclick} type="PageClick"/>}
            tablist={PerformaceTab}
            title="Performance"
          />
        </Col>
        <Col className="mb-3" sm={12} md={6} lg={6}>
          <PerformChart
            element={<LineChart data={!facebookSetting?.userAccountId?ReachDummy:Reach} type="Reach" />}
            element1={<LineChart data={!facebookSetting?.userAccountId?Impressions:Impression} type="Impression"/>}
            tablist={ReachAndImpressionTab}
            data={Impressions}
            title="Reach and Impressions"
          />
        </Col>
      </Row>
      <Row className="mb-3">
      {/*   <Col className="mb-3" md={12} lg={4}>
          <ChartBox element={<Chart />} title="Post & Engagements"/>
          <Feedback tablist={PostAndEngagement} />
        </Col> */}
        <Col className="mb-3" sm={12} md={6} lg={6}>
          <FacebookChart
            element={<LineChart  data={!facebookSetting?.userAccountId?Clicks:linkclicks}   type="PageClick" />}
            // element={<AgeCompareChart data={FacebookAge} />}
            tablist={FacebookTab}
            title="Facebook"
          />
        </Col>
        {/* <Col className="mb-3" sm={12} md={6} lg={6}>
          <InstagramChart
            tablist={InstagramTab}
            element={<ChartMin line={2} data="" type="" />}
            title="Instagram"
          />
        </Col> */}
      </Row>
    </>
  );
}
export default SocialMediaAnalytics;
